import { render } from "./AreaCodePhoneNumberInput.vue?vue&type=template&id=f0dcb9e2&scoped=true"
import script from "./AreaCodePhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./AreaCodePhoneNumberInput.vue?vue&type=script&lang=js"

import "./AreaCodePhoneNumberInput.vue?vue&type=style&index=0&id=f0dcb9e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0dcb9e2"]])

export default __exports__